import { BrowserRouter, Navigate, Route, Routes } from "react-router"
import { DescadastroPage } from "./features/descadastro/DescadastroPage"
import { RepassePage } from "./features/repasse/RepassePage"
import { VisaoPage } from "./features/visao/VisaoPage"

export const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/repasse" element={<RepassePage />} />
            <Route path="/visao" element={<VisaoPage />} />
            <Route path="/descadastro" element={<DescadastroPage />} />
            {/* Toda entrada vem de um link do e-mail. Sem rota conhecida, cai na tela do repasse,
                que é a que o link mensal abre, em vez de mostrar um 404 para quem clicou de boa fé. */}
            <Route path="*" element={<Navigate to="/repasse" replace />} />
        </Routes>
    </BrowserRouter>
)
